import { render, staticRenderFns } from "./reestrdoc.vue?vue&type=template&id=4376b82a&"
import script from "./reestrdoc.vue?vue&type=script&lang=js&"
export * from "./reestrdoc.vue?vue&type=script&lang=js&"
import style0 from "./reestrdoc.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports